import React, {useState} from 'react';
import {Td} from "@chakra-ui/react";
import WorkflowLevel from "./Workflow/WorkflowLevel";
import LanguageLevel from "./Workflow/LanguageLevel";
import {IProject} from "../../models/interfaces/project.interface.ts";
import {motion, AnimatePresence} from "framer-motion";
import {downloadFeatures} from "../../services/projectService.ts";

interface ProjectTableWorkflowProps {
  project: IProject
}

const WORKFLOW_LEVEL = 0;
const TRANSLATION_LEVEL = 1;
const AUDIO_DESCRIPTION_LEVEL = 2;


const ProjectTableWorkflow: React.FC<ProjectTableWorkflowProps> = ({project}: ProjectTableWorkflowProps) => {
  const [level, setLevel] = useState<number>(WORKFLOW_LEVEL);
  const [hoveredStep, setHoveredStep] = React.useState<string | null>(null);

  const downloadSpecific = (stepId: string, language?: string): void => {
    const info: {
      subtitles?: string[],
      audioDescriptions?: string[],
      dialogueList?: boolean,
      extendedMetadata?: boolean,
    } = {}
    if (stepId === 'transcription' || stepId === "subtitleTranslations") {
      if (language) {
        info["subtitles"] = [language]
      }
    } else if (stepId === 'audioDescriptions') {
      if (language) {
        info["audioDescriptions"] = [language]
      }
    } else if (stepId === 'dialogueList') {
      info["dialogueList"] = true;
    } else if (stepId === 'extendedMetadata') {
      info["extendedMetadata"] = true;
    } else {
      console.error("Unknown stepId:", stepId);
      return;
    }
    downloadFeatures(project.id, project.name, info).catch(console.error);
  }


  return (
    <Td className="max-w-[400px] overflow-x-auto" textAlign="left">
      <AnimatePresence mode="wait">
        {level === WORKFLOW_LEVEL && (
          <motion.div
            key="workflow"
            initial={{opacity: 0, y: 10}}
            animate={{opacity: 1, y: 0}}
            exit={{opacity: 0, y: -10}}
            transition={{duration: 0.1}}
          >
            <WorkflowLevel
              project={project}
              hoveredStep={hoveredStep}
              setHoveredStep={setHoveredStep}
              onEnterLevel={setLevel}
              downloadSpecific={downloadSpecific}
            />
          </motion.div>
        )}
        {level === TRANSLATION_LEVEL && (
          <motion.div
            key="translations"
            initial={{opacity: 0, y: 10}}
            animate={{opacity: 1, y: 0}}
            exit={{opacity: 0, y: -10}}
            transition={{duration: 0.1}}
          >
            <LanguageLevel
              items={project.featuresStates.subtitleTranslations!}
              type="subtitleTranslations"
              hoveredStep={hoveredStep}
              setHoveredStep={setHoveredStep}
              goBack={() => setLevel(WORKFLOW_LEVEL)}
              downloadSpecific={downloadSpecific}
            />
          </motion.div>
        )}
        {level === AUDIO_DESCRIPTION_LEVEL && (
          <motion.div
            key="audioDescriptions"
            initial={{opacity: 0, y: 10}}
            animate={{opacity: 1, y: 0}}
            exit={{opacity: 0, y: -10}}
            transition={{duration: 0.1}}
          >
            <LanguageLevel
              items={project.featuresStates.audioDescriptions!}
              type="audioDescriptions"
              hoveredStep={hoveredStep}
              setHoveredStep={setHoveredStep}
              goBack={() => setLevel(WORKFLOW_LEVEL)}
              downloadSpecific={downloadSpecific}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </Td>
  );
}

export default ProjectTableWorkflow;